import { render } from "./TemplateEdit.vue?vue&type=template&id=fb4bc674&scoped=true"
import script from "./TemplateEdit.vue?vue&type=script&lang=js"
export * from "./TemplateEdit.vue?vue&type=script&lang=js"

import "./TemplateEdit.vue?vue&type=style&index=0&id=fb4bc674&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb4bc674"]])

export default __exports__